import { useContext, useEffect, useState } from "react";
import Button1 from "../../../Button/Button1"
import { RuleProvider, useRule } from "./RuleReducer";
import ListOption from "../EditAutomations/ListOption";
import Button2 from "../../../Button/Button2";
import classes from '../CreateRule/SelectOutputs.module.css'
import ProgressBar from "./ProgressBar";

const ChooseWhen = ({navigate}) => {

    const [disabled, setDisabled] = useState(true)
    const [progress, setProgress] = useState(40)

    useEffect(() => {
        console.log("here")
    }, [])

    const { state, dispatch } = useRule(RuleProvider);

    const HandleChooseWhenSelected = (selection) => {
        console.log(selection)
        dispatch({type: "SET_INPUT_TYPE", payload: selection})
        dispatch({type: "SET_INPUT_TYPE_COPY", payload: selection})

        setDisabled(false)
    }

    const HandleText = () => {
        let inputType;
        switch (state.inputTypeCopy) {
            case 0:
                inputType = `${state.pinStatusOn}`;
                break;
            case 1: 
                inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`;
                break;
            case 2:
                inputType = `${state.pinStatusOff}`;
                break;
            case 3:
                inputType = `${state.pinStatusOn}`;
                break;
            case 4:
                inputType = `${state.pinStatusOn}`;
                break;
            default:
                inputType = "unknown";
                break;
        }
        
        if (state.isLock){
            inputType = "opened" 
        }

        return `When ${state.pinName} is ${inputType}`
    }

    const HandleNavigate = (direction) => {
        if (direction === "back"){
            navigate(0)
        } else {
           navigate(2) 
        }
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px", width:"80%" }}>
            <ProgressBar progress={progress} />
            <div style={{display: "flex", flexDirection:"row", alignItems:"center", justifyContent:"space-between", gap: "20px"}}>
                <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                <ListOption optionText={HandleText()} propsClassName={classes.infoBox} />
                <button className={classes.nextButton} onClick={() => HandleNavigate("next")} >{">"}</button>
            </div>
            <h3 style={{ color:"#6e6e6e"}}>When should the rule trigger?</h3>
            <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <Button2 style={{ 
                                minWidth: "350px", 
                                minHeight:"50px", 
                                backgroundColor: state.inputType == 0 && 
                                "var(--Primary-Color)", color: state.inputType == 0 && 
                                "white", 
                                border: state.inputType == 0 && 
                                "2px solid lightblue", minWidth: "300px"}
                            }   
                            onClick={() => HandleChooseWhenSelected(0)} > {"is " + state.pinStatusOn}</Button2>
                <Button2 style={{ 
                                minWidth: "350px", 
                                minHeight:"50px",
                                backgroundColor: state.inputType == 1 && 
                                "var(--Primary-Color)", color: state.inputType == 1 && 
                                "white", 
                                border: state.inputType == 1 && 
                                "2px solid lightblue", minWidth: "300px"}
                            }  
                            onClick={() => HandleChooseWhenSelected(1)}>{"is " + state.pinStatusOn + " or " + state.pinStatusOff}</Button2>
                <Button2 style={{ 
                                minWidth: "350px", 
                                minHeight:"50px",
                                backgroundColor: state.inputType == 2 && 
                                "var(--Primary-Color)", color: state.inputType == 2 && 
                                "white", 
                                border: state.inputType == 2 && 
                                "2px solid lightblue", minWidth: "300px"}
                            }  
                            onClick={() => HandleChooseWhenSelected(2)}>{"is " + state.pinStatusOff}</Button2>
            </ul>
        </div>
    )
}

export default ChooseWhen;